<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45">
            MAGDA PORTAL <br>
            <span style="line-height: 100%;" class="fontMS300">
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio13/magda-portal">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio13/magda-portal">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio13/magda-portal">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img001.jpg">
</section>

<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-center  font-24">
                    MAGDA PORTAL (1900-1989), NO SOLO ES RECONOCIDA COMO POETA VANGUARDISTA, SINO COMO LUCHADORA SOCIAL 
                    Y DEFENSORA DE LOS DERECHOS DE LAS MUJERES EN EL PERÚ. APOSTÓ POR UN ARTE REVOLUCIONARIO, LIBRE Y HUMANO. 
                    DEBIDO A SU PARTICIPACIÓN POLÍTICA, SUFRIÓ PERSECUCIONES, FUE ENCARCELADA Y DEPORTADA. DE ESPÍRITU REBELDE Y 
                    CONTESTATARIO, SE MANTUVO FIEL A SUS IDEALES A LO LARGO DE SU VIDA.
                    <br>
                </p>
                <p class="fontMS100 text-justify  font-24 text-gris">
                    <br>
                    A través de su obra es posible trazar la historia política, social y cultural del país a lo largo del siglo XX. 
                    Sus primeras publicaciones –poesía, cuento y ensayo– reflejan su posicionamiento dentro de la vanguardia latinoamericana. 
                    Sus folletos y fotografías demuestran el impacto que tuvo como dirigente política en una época en que se daban pocas 
                    oportunidades a las mujeres. Sus manuscritos inéditos y su correspondencia personal dan fe de su compromiso con las 
                    causas sociales, y revelan las numerosas dificultades que tuvo que enfrentar y la tenacidad que la acompañó hasta sus últimos días.
                    <br>
                </p>
                <br><br><br>
                <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br><br><br><br><br><br>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS300 text-center colorPrincipal  font-40">
                            LA COLECCIÓN
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal  font-40">
                    MAGDA PORTAL
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                </div>
                <p class="fontMS500 text-justify  font-24">
                    <br>
                    A PESAR DE LOS CONSTANTES EXILIOS, VIAJES Y PERSECUCIONES POLÍTICAS, MAGDA PORTAL SE ESMERÓ POR
                    CONSERVAR SU ARCHIVO.
                    <br>
                </p>
                <div class="row">
                    <div class="col-sm-6 p-5">
                        <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img002.jpg">
                        <span class="fontMS100Italic font-12">
                            Magda Portal. México, 1928. Archivo de la Biblioteca de la Universidad de Texas en Austin,
                            Colección Latinoamericana Nettie Lee Benson.
                        </span>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 text-justify  font-24">
                            <br>
                            En la colección que conserva la Biblioteca Nacional del Perú se encuentran manuscritos originales 
                            de sus ensayos, ponencias y obras literarias, así como su extensa correspondencia con políticos, 
                            activistas, poetas e investigadores de diversos países.
                            <br><br>
                            Magda Portal sufrió la pérdida de su equipaje durante un viaje a Buenos Aires en el año 1951, 
                            por lo que perdió casi toda su obra inédita hasta ese momento. Por ello, gran parte de los 
                            documentos son de la segunda mitad del siglo XX. Los recuerdos de la autora, así como las primeras 
                            ediciones de sus publicaciones, sirven para reconstruir las primeras etapas de su trayectoria.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris_Img">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            EL NUEVO POEMA
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada2.png">
                    </div>
                </div>
                <p class="fontMS500 text-center  font-24">
                    <br><br>
                    CUANDO MAGDA PORTAL TIENE APENAS VEINTICINCO AÑOS, JOSÉ CARLOS MARIÁTEGUI DECLARA QUE ELLA ES UN 
                    VALOR-SIGNO DENTRO DE LA LITERATURA PERUANA. CELEBRA LA VITALIDAD Y FUERZA DE SU OBRA, 
                    Y ACLAMA SU VOZ LÍRICA Y HUMANA.
                    <br>
                </p>
                <p class="text-justify  font-24">
                    <br>
                    DDurante esos mismos años, la joven poeta empieza a colaborar en revistas vanguardistas con cuentos, 
                    poemas y ensayos, entre las que se encuentran  <span class="fontMS100Italic">Amauta</span>, del mismo Mariátegui, el <span
                        class="fontMS100Italic">Boletín Titikaka</span>, dirigida por Gamaliel Churata desde Puno, y
                    <span class="fontMS100Italic">Guerrilla</span>, dirigida por la poeta uruguaya Blanca Luz Brum.
                    Además, codirige <span class="fontMS100Italic">Flechas</span> y la efímera revista <span
                        class="fontMS100Italic">Trampolín-Hangar-Rascacielos-Timonel</span>, que cambiaba de título
                    con cada número.
                    <br><br>
                    En 1926, junto a Serafín Delmar (Reynaldo Bolaños Díaz) publica <span class="fontMS100Italic">El derecho de matar</span>, un 
                    libro de cuentos de corte vanguardista y revolucionario, y de carácter violento. Al año siguiente publica su poemario <span
                        class="fontMS100Italic">Una esperanza i el mar</span>. Finalmente, se destacan dos ensayos en 
                        los cuales da a conocer su visión del arte. En “Andamios de vida”, publicado en <span
                        class="fontMS100Italic">Amauta</span>, y “El nuevo poema”, la autora apuesta por 
                        un arte innovador, libre y socialmente comprometido con la creación de una sociedad más justa.
                    <br><br>
                </p>
                <div class="row menuWebPhone">
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/79274" target="_blank">
                            <img class="imgNP" width="100%"
                                src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img003.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/79171" target="_blank">

                            <img class="imgNP" width="100%"
                                src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img004.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/79616" target="_blank">

                            <img class="imgNP" width="100%"
                                src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img005.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/79170" target="_blank">

                            <img class="imgNP" width="100%"
                                src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img006.jpg">
                        </a>
                    </div>
                </div>
                <!--TABLET-->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="http://hdl.handle.net/20.500.14428/79274" target="_blank">
                                <img class="imgNP" width="100%"
                                    src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img003.jpg">
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="http://hdl.handle.net/20.500.14428/79171" target="_blank">

                                <img class="imgNP" width="100%"
                                    src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img004.jpg">
                            </a>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="http://hdl.handle.net/20.500.14428/79616" target="_blank">

                                <img class="imgNP" width="100%"
                                    src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img005.jpg">
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="http://hdl.handle.net/20.500.14428/79170" target="_blank">
                                <img class="imgNP" width="100%"
                                    src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img006.jpg">
                            </a>
                        </div>
                    </div>
                </div>
                <br><br><br>
                <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br><br><br><br><br><br>
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            PARTICIPACIÓN POLÍTICA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal  font-40">
                    Y EXILIOS
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                </div>
                <p class="fontMS500 text-center  font-24">
                    <br><br>
                    EN JUNIO DE 1927, EL GOBIERNO DE AUGUSTO B. LEGUÍA INTERVIENE VARIOS LOCALES EN LIMA BAJO LA
                    PRETENSIÓN DE SOFOCAR UN COMPLOT COMUNISTA.
                    <br>
                </p>
                <p class="text-justify font-24">
                    <br>
                    Magda Portal y Serafín Delmar están entre los implicados en el taller de la Editorial Minerva 
                    (fundada por J. C. Mariátegui), por lo que son deportados, primero a Cuba y después a México. 
                    En 1928, junto con otros desterrados peruanos, como Víctor Raúl Haya de la Torre, Magda Portal 
                    firmará el “Plan de México”, en el que se planteaba la necesidad de fundar un partido alineado 
                    a la Alianza Popular Revolucionaria Americana (APRA). Dos años después, Magda Portal es la única 
                    mujer que participa en la fundación del Partido Aprista Peruano (PAP).
                    <br><br>
                    Motivada por la justicia social y la lucha antiimperialista, dedicará casi dos décadas de su 
                    vida al llamado "Partido del pueblo". Durante ese tiempo sufre exilios, persecuciones y encarcelamiento. 
                    También sufre grandes decepciones. A fines de la década de 1940, varios factores la llevarán a separarse 
                    del Partido Aprista Peruano de manera definitiva, entre los más importantes estaban, el abandono de sus 
                    postulados originarios y que no se considere a las mujeres como militantes del partido.

                    <br><br><br>
                </p>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;" class="fontMS500 text-center font-24">
                            INICIACIÓN EN LA POLÍTICA
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3">

                    </div>
                    <div class="col-sm-6">
                        <p>
                            <br>
                        </p>
                        <img class="imgNP1" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img007.jpg">
                        <br><span class="fontMS100Italic font-12">
                            Magda Portal, Esteban Pavletich, Carlos Manuel Cox, Serafín Delmar, Víctor Raúl Haya de la
                            Torre. México, 1928. Archivo de la Biblioteca de la Universidad de Texas en Austin,
                            Colección Latinoamericana Nettie Lee Benson.
                        </span>
                    </div>
                    <div class="col-sm-3">

                    </div>
                </div>
                <p class="text-justify font-24">
                    <br>
                    En 1923, Magda Portal conoce a las dos figuras que marcarían su trayectoria política. Escucha por
                    primera vez a Víctor Raúl Haya de la Torre en las agitadas movilizaciones estudiantiles y obreras, y
                    también acude a los encuentros en la casa de José Carlos Mariátegui para aprender de su “palabra
                    vital”.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/79275" target="_blank" style="color: black;">
                            <img class="imgNP" width="100%"
                                src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img008.jpg">
                        </a>
                        <br><br><br><br><br>
                    </div>
                    <div class="col-sm-4">
                        <a href="https://hdl.handle.net/20.500.14428/65130" target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img009.jpg">
                        </a>
                        <br><br><br><br><br>
                    </div>
                    <div class="col-sm-2"></div>
                </div>
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;" class="fontMS500 text-center font-24">
                            GIRAS NACIONALES E INTERNACIONALES
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                    </div>
                </div>
                <div class="row mb-5">
                    <div class="col-sm-1">
                    </div>
                    <div class="col-sm-5">
                        <p>
                            <br>
                        </p>
                        <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img010.jpg">
                        <br><span class="fontMS100Italic font-12">
                            Mitin de bienvenida a Magda Portal. Trujillo, 1946. Archivo de la Biblioteca de la
                            Universidad de Texas en Austin, Colección Latinoamericana Nettie Lee Benson.
                        </span>
                    </div>
                    <div class="col-sm-5">
                        <p class="font-24">
                            <br>
                            A fines de la década de 1920, bajo el gobierno de Leguía, Magda Portal parte el exilio 
                            y viaja por Latinoamérica y el Caribe para difundir las propuestas antiimperialistas del APRA. 
                            Pasa por Cuba, Puerto Rico, la República Dominicana, Costa Rica, Colombia y México. 
                            De regreso al Perú, en 1930, realiza giras por el sur del país en las que fomenta la participación política de la mujer. 
                            La prohibición y represión la lleva a la cárcel durante el gobierno de Óscar Benavides por casi año y medio (1934-1936). 
                            Luego, sufrió otro destierro, esta vez a Chile (1939-1945).

                        </p>
                    </div>
                    <div class="col-sm-1">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-8">
                        <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img011.jpg">
                        <span class="fontMS100Italic font-12">
                            <br>Escuela Nacional de Lampa. s/f. Archivo de la Biblioteca de la Universidad de Texas en
                            Austin, Colección Latinoamericana Nettie Lee Benson.
                        </span>
                    </div>
                    <div class="col-sm-4"></div>
                    <br><br>
                </div>
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;" class="fontMS500 text-center font-24">
                            LA MUJER EN LA POLÍTICA PERUANA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                    </div>
                </div>
                <p class="text-justify font-24">
                    <br><br>
                    En 1945, cuando Magda Portal vuelve al Perú, asume la Secretaría del Comando de Capacitación 
                    Femenina del Partido Aprista y emprende un viaje por todas las regiones del país para involucrar 
                    a las mujeres en el proceso político. En 1946, organiza la Primera convención nacional de mujeres apristas, 
                    y en su discurso inaugural, desafiando al partido, argumentó a favor del voto femenino, y declaró que 
                    no puede negársele a la mujer el pleno ejercicio de sus derechos.
                    <br><br>

                </p>
                <div class="row">
                    <div class="col-sm-4 mb-5">
                        <a href="http://hdl.handle.net/20.500.14428/79172" target="_blank" style="color: black;">
                            <img class="imgNP" width="100%"
                                src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img014.jpg">
                        </a>
                    </div>
                    <div class="col-sm-8">
                        <img width="93%" class="imgNP"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img015.jpg">
                        <br><span class="fontMS100Italic font-12">
                            Convención de mujeres apristas. Lima, 1946. Fuente: Archivo de Rocío Revolledo.
                        </span>
                        <br><br><br><br>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;" class="fontMS500 text-center font-24">
                            RUPTURA CON EL APRA
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5">
                        <br><br><br>
                        <a href="http://hdl.handle.net/20.500.14428/79167" target="_blank"
                            style="color: black;">
                            <img class="imgNP" width="90%"
                                src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img016.jpg">
                        </a>
                    </div>
                    <div class="col-sm-5">
                        <p class="text-justify font-24">
                            <br>
                            En 1948, en la segunda convención nacional del partido, Víctor Raúl Haya de la Torre rechazó 
                            las propuestas de Magda Portal acerca de la participación política de las mujeres. 
                            Este evento significó el inicio de su ruptura con el partido. Además, ella expresó 
                            su desacuerdo con el distanciamiento del partido de sus principios antiimperialistas 
                            y la indiferencia de los líderes hacia los jóvenes militantes que habían sido detenidos 
                            o ejecutados. Desarrolló estas críticas con más profusión en dos textos: <span class="fontMS100Italic">¿Quiénes traicionaron el
                                pueblo?</span>, una defensa legal del año 1950, y su única novela <span
                                class="fontMS100Italic">La trampa.</span> <br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                    <br><br><br>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA_RESALTE.png" width="100%">
                <p class="text-justify text-white fontMS500 font-24">
                    <br>
                    <span>
                        MI VOCACIÓN ESENCIAL SIEMPRE HA SIDO LA POESÍA; LO DEMÁS, ES UNA ENORME NECESIDAD DE
                        COMUNICACIÓN. EN MÍ, ESCRIBIR ES COMUNICARME, A PESAR DE QUE TENGO UN POEMA QUE DICE: “LE TENGO
                        TANTO MIEDO A LAS PALABRAS, POR ESO ESTOY CALLADA”… PERO HAY UNA NECESIDAD DE COMUNICACIÓN, Y
                        CUANDO SE PRESENTA LA OPORTUNIDAD, QUIERO DECIR TANTAS COSAS, Y NO LAS PUEDO DECIR TODAS EN LA
                        POESÍA.
                    </span>
                </p>
                <p class="text-right fontMS300Italic font-24 text-white">
                    <span>
                        MAGDA PORTAL, 1978.
                    </span>
                    <br>
                </p>
                <img src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA_RESALTE.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-38">
                            DEFENSORA DE LOS DERECHOS
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS300 text-center colorPrincipal font-40">
                    DE LA MUJER
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br><br>
                    EN UN PRIMER MOMENTO MAGDA PORTAL SE DISTANCIA DE LA LUCHA FEMINISTA Y SUFRAGISTA, PUESTO QUE LA
                    CONSIDERA UN MOVIMIENTO DE MUJERES DE CLASE ALTA. ELLA MÁS BIEN APUESTA POR LA REVOLUCIÓN SOCIAL
                    PARA EMANCIPAR A TODOS LOS OPRIMIDOS.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-2">
                        <br>
                    </div>
                    <div class="col-sm-8">
                        <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img017.jpg">
                        <br><span class="fontMS100Italic font-12">
                            Ana María Portugal, Magda Portal y René Castro Pozo en una presentación de ALIMUPER. Lima,
                            1978. Archivo de la Biblioteca de la Universidad de Texas en Austin, Colección
                            Latinoamericana Nettie Lee Benson.
                        </span>
                    </div>
                    <div class="col-sm-2">
                        <br>
                    </div>
                </div>
                <p class="text-justify font-24">
                    <br><br>
                    Esta postura se complejiza a partir de sus experiencias en los años 30 y 40. Ella experimenta y observa 
                    de primera mano la violencia de género ejercida por el Estado contra las militantes e incluso contra 
                    las madres, hermanas e hijas de los militantes de su partido. Por otro lado, sus giras políticas le 
                    permiten conocer la lucha cotidiana de las mujeres de las diferentes regiones del país. A partir de 
                    estas experiencias, Magda Portal reconoce los sacrificios y las capacidades de la mujer peruana y exige su inclusión en el proceso político.
                    <br><br>
                    Desde fines de la década del setenta, una nueva generación de activistas feministas la ven como pionera 
                    en la lucha por los derechos de la mujer. Con más de setenta años, Magda Portal se involucra con el movimiento, 
                    participa en Acción para la Liberación de la Mujer Peruana (ALIMUPER), publica un ensayo dedicado a Flora Tristán, 
                    y reflexiona sobre las escritoras peruanas, los derechos de las mujeres y, como siempre, sobre la injusticia en todas sus formas.
                    <br>
                </p>
            </div>
        </div>
        <div class="w-90 text-center mt-5 ml-auto mr-auto">
            <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
                <div ngxSlickItem *ngFor="let slide of slides" class="slide p-2">
                    <a href="{{slide.id}}" target="_blank" style="color: inherit;">
                        <div class="divLibros text-center w-100">
                            <p class="text-center">
                                <img src="{{ slide.img }}" alt="" width="100%">
                            </p>
                            <div class="divNombresLibros mb-3">
                                <p class="text-center">
                                    <span class="fontMS500">{{slide.autor}}</span><br>
                                    <span>{{slide.titulo}}</span><br>
                                    <span>{{slide.ano}}</span>
                                </p>
                            </div>
                        </div>
                    </a>
                </div>
            </ngx-slick-carousel>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-8">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            LA ESPERANZA DE UN MUNDO MEJOR
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada4.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-bottom: 0%;"
                    class="fontMS300 text-center colorPrincipal font-40 bottom_cel">
                    LA CORRESPONDENCIA DE MAGDA PORTAL
                </p>
                <p style="line-height: 100%;margin-bottom: 2%;"
                    class="fontMS300 text-center colorPrincipal font-40 c100">
                    LA CORRESPONDENCIA DE MAGDA PORTAL
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br><br>
                    A LO LARGO DE SU VIDA, MAGDA PORTAL MANTIENE UNA CORRESPONDENCIA FRECUENTE, EN UN 
                    LENGUAJE FRANCO Y ABIERTO, CON UNA VARIEDAD DE PERSONAJES RECONOCIDOS EN EL MEDIO. 
                    SE CARTEA CON EDITORES, INVESTIGADORES, POETAS Y ACTIVISTAS, Y CON VIEJAS AMISTADES Y JÓVENES PROMESAS.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5">
                        <br><br>
                        <img class="imgNP" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img024.jpg">
                        <br><span class="fontMS100Italic font-18">
                            Magda Portal en su escritorio. Foto: Víctor Ch. Vargas. Lima, 1981. Archivo Caretas. </span>

                        <br><br><br>
                    </div>
                    <div class="col-sm-6">
                        <p class="text-justify font-24">
                            <br>
                            La presente selección de cartas abarca desde 1959 hasta 1981, período en el cual Magda Portal 
                            se aleja de la política y se dedica a la escritura, la labor editorial y la reivindicación de 
                            las mujeres. Las cartas revelan un compromiso permanente con sus ideales. En todo momento está 
                            atenta a la situación política, económica y social del país. A través de estos intercambios 
                            también se puede vislumbrar el carácter singular de Magda Portal. Demuestra ser una amiga considerada 
                            y franca. También es exigente, y se decepciona fácilmente frente a la falta de compromiso de los demás. 
                            Aunque mencionaba frecuentemente su cansancio físico y emocional, siguió siendo tenaz hasta sus últimos días.<br><br>
                        </p>
                    </div>
                    <br><br><br>
                </div>
                <div class="row">
                    <div class="col-sm-5">
                        <img class="LineSubsec_Izq2" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                    </div>
                    <div class="col-sm-2">
                        <p style="line-height: 160%;margin-bottom: 0%;" class="fontMS500 text-center font-24">
                            POLÍTICA
                        </p>
                    </div>
                    <div class="col-sm-5">
                        <img class="LineSubsec_Izq2" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-sm-4 p-3">
                        <a href="http://hdl.handle.net/20.500.14428/79288" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img025.jpg">
                        </a>
                    </div>
                    <div class="col-sm-4 p-3">
                        <a href="http://hdl.handle.net/20.500.14428/79292" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img026.jpg">
                        </a>
                    </div>
                    <div class="col-sm-4 p-3">
                        <a href="https://hdl.handle.net/20.500.14428/76923" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img027.jpg">
                        </a>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 180%;margin-bottom: 0%;" class="fontMS500 text-center font-24">
                            INSPIRACIÓN PARA LAS NUEVAS GENERACIONES
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-sm-3 p-3">
                        <br>
                    </div>
                    <div class="col-sm-3 p-3">
                        <a href="http://hdl.handle.net/20.500.14428/79286" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img028.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3 p-3">
                        <a href="http://hdl.handle.net/20.500.14428/79280" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img029.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3 p-3">
                        <br>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 200%;margin-bottom: 0%;" class="fontMS500 text-center font-24">
                            AMISTAD ENTRE ESCRITORAS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-sm-3 p-3">
                        <a href="http://hdl.handle.net/20.500.14428/79287" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img033.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3 p-3">
                        <a href="http://hdl.handle.net/20.500.14428/79291" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img030.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3 p-3">
                        <a href="http://hdl.handle.net/20.500.14428/79289" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img031.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3 p-3">
                        <a href="http://hdl.handle.net/20.500.14428/79277" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img032.jpg">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoMorado">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <!-- <div class="col-sm-4">
                        <img class="img-fluid mb-3 pointer" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img008c.jpg">
                    </div> -->
                    <div class="col-sm-12">
                        <p class="text-white fontMS500 font-24">
                            Magda Portal siempre tuvo ideales claros vinculados a la justicia e igualdad. Fue una
                            pensadora apasionada, exigente y autocrítica.

                        </p>
                    </div>
                    <div class="col-sm-12 mb-5 mt-4">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            Selecciona un poema de <span class="fontMS500Italic">Una esperanza i el mar</span> y comenta
                            lo que más te llama la atención. ¿Cómo se vincula su poesía con sus ideales?

                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            Entre las década de 1930 y 1940, Magda Portal recogió información sobre la situación
                            laboral, familiar y educativa de las mujeres peruanas. Te invitamos a investigar sobre la
                            situación actual de la mujer en nuestro país. ¿Qué mejoras hay en relación a los derechos de
                            la mujer?

                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            Te invitamos a escribir una carta a uno de tus amigos o familiares compartiendo tu lectura
                            sobre Magda Portal y enviarla por correo postal. ¿Qué diferencias encuentras con la
                            comunicación por redes sociales?

                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada2.png">
                    </div>
                </div>
                <p class="fontMS100 font-24">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">

                        <p class="font-24">
                            <br>
                            <span class="fontMS500">García-Bryce, I. (2015). </span><br>
                            <span class="fontMS100Italic text-gris"> Activista transnacional: Magda Portal y el Apra,
                                1926-1950. </span>
                            <span class="text-gris">En Nueva Corónica (5): 193-222. </span><br>
                            <a href="https://www.academia.edu/11133278/Activista_transnacional_Magda_Portal_y_el_APRA_1926_1950"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Gonzales-Smith, M. (2007). </span><br>
                            <span class="fontMS100Italic text-gris">Poética e ideología en Magda Portal: otras
                                dimensiones de la vanguardia en Latinoamérica. </span><br>
                            <span class="text-gris">Lima: Instituto de Estudios Peruanos. </span><br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=347116" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Portal, Magda (2017).</span><br>
                            <span class="fontMS100Italic text-gris">La vida que yo viví. Autobiografía de Magda
                                Portal.
                            </span>
                            <span class="text-gris"> Lima: Casa de la Literatura Peruana.</span><br>
                            <a href="http://www.casadelaliteratura.gob.pe/wp-content/uploads/2018/02/La-vida-que-yo-vivi-Autobiografia-Magda-Portal.pdf"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Reedy, D. (2000).</span><br>
                            <span class="fontMS100Italic text-gris">Magda Portal, la pasionaria peruana: biografía
                                intelectual.
                            </span>
                            <span class="text-gris">Lima: Eds. Flora Tristán.</span><br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=281397" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">VV.AA. (2018).</span><br>
                            <span class="fontMS100Italic text-gris">Libros & Artes.</span>
                            <span class="text-gris">Año N° 93-94.</span><br>
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/libros-y-artes-93-94/"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">VV.AA. (2017).</span><br>
                            <span class="fontMS100Italic text-gris">
                                Trazos cortados: Poesía y rebeldía de Magda Portal [Catálogo].
                            </span>
                            <span class="text-gris">Lima: Casa de la Literatura Peruana.</span><br>
                            <a href="http://www.casadelaliteratura.gob.pe/wp-content/uploads/2018/08/catalogo_MAGDA-PORTAL.pdf"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>